import type { GatewayAssetOut } from "../../../kubb";
import type { Asset } from "../../../utils/object.tsx";

export function isGatewayAsset(asset: Asset): asset is GatewayAssetOut {
  return (asset as GatewayAssetOut).asset_type === "gateway";
}
